import { intl } from '@beelday/common'
import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import { useState } from 'react'
import { useRecordingUser } from './use-recording-user'

const pulse = keyframes`
	0%, 100% { opacity: 1; }
	50% { opacity: 0.3; }
`

// row-reverse so the REC handle stays on the right and the label expands leftward
const Wrapper = styled.div<{ expanded: boolean }>`
	position: fixed;
	right: 108px;
	top: 18px;
	z-index: 10000;
	display: flex;
	flex-direction: row-reverse;
	align-items: center;
	background: rgba(15, 15, 15, 0.85);
	backdrop-filter: blur(4px);
	border-radius: 10px;
	width: ${({ expanded }) => (expanded ? '280px' : '58px')};
	overflow: hidden;
	transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	cursor: default;
	user-select: none;
	box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.4);
`

const Handle = styled.div`
	display: flex;
	align-items: center;
	flex-shrink: 0;
	padding: 10px 12px 10px 8px;
	gap: 6px;
`

const RecDot = styled.div`
	width: 10px;
	height: 10px;
	background-color: #e53935;
	border-radius: 50%;
	flex-shrink: 0;
	animation: ${pulse} 1.6s ease-in-out infinite;
`

const RecLabel = styled.span`
	font-size: 11px;
	font-weight: 700;
	color: #e53935;
	letter-spacing: 0.05em;
	flex-shrink: 0;
`

const Divider = styled.div`
	width: 1px;
	height: 20px;
	background: rgba(255, 255, 255, 0.2);
	flex-shrink: 0;
	margin: 0 10px 0 8px;
`

const Text = styled.span<{ visible: boolean }>`
	font-size: 12px;
	font-weight: 400;
	color: rgba(255, 255, 255, 0.9);
	white-space: nowrap;
	padding-left: 14px;
	opacity: ${({ visible }) => (visible ? 1 : 0)};
	transition: opacity 0.15s ease ${({ visible }) => (visible ? '0.15s' : '0s')};
`

export const RecordingIndicator = (): JSX.Element | null => {
	const { active } = useRecordingUser()
	const [expanded, setExpanded] = useState(false)

	if (!active) return null

	return (
		<Wrapper
			expanded={expanded}
			onMouseEnter={() => setExpanded(true)}
			onMouseLeave={() => setExpanded(false)}
		>
			<Handle>
				<RecDot />
				<RecLabel>REC</RecLabel>
			</Handle>
			<Divider />
			<Text visible={expanded}>
				<intl.Translate>recording.indicator.being_recorded</intl.Translate>
			</Text>
		</Wrapper>
	)
}
